import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RaportData, SearchRapoartePayload } from './rapoarte-activitate.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RapoarteActivitateService {
    private httpOptions: any;
    private basePath = environment.interop.basePath;

    private getRapoarteUrl =
        this.basePath + environment.interop.indoc.rapoarteActivitati.getRapoarte;

    public exportFileUrl =
        this.basePath + environment.interop.indoc.rapoarteActivitati.getRapoarte;

    constructor(private http: HttpClient) { }

    getRapoarte(payload: SearchRapoartePayload) {
        return this.http
            .post<{ errors: boolean; data: RaportData[]; status_code: number }>(
                this.getRapoarteUrl, payload
            ).pipe(
                map((response) => response.data),
                catchError((error) => {
                    console.error('Error in searching rapoarte:', error);
                    return throwError(error);
                })
            );
    }
}
